import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { leadEndpoints } from '@/lib/api/endpoints';
import { leadKeys } from '@/lib/queryKeys';
import type { LeadListParams, LeadListResponse } from '@/types/lead';

export function useLeads(params: LeadListParams = {}, options?: { enabled?: boolean }) {
  return useApiQuery<LeadListResponse>({
    queryKey: leadKeys.list(params),
    queryFn: () =>
      apiGet<LeadListResponse>(operationsClient, leadEndpoints.list(), {
        params: params as Record<string, unknown>,
      }),
    showErrorToast: false,
    enabled: options?.enabled,
  });
}
